<template>
  <div class="property-tab">
    <div class="property-title">State Name:</div>
    <v-tooltip :disabled="stateName.length < 1" location="bottom">
      <template #activator="{ props }">
        <v-text-field
          v-model="stateName"
          density="compact"
          hide-details
          single-line
          variant="outlined"
          v-bind="props"
          class="flex-grow-0 field-bordered"
          :disabled="PreferenceStore.INSTANCE.isReadOnly"
          @focus="onFocus"
          @blur="onBlur"
        ></v-text-field>
      </template>
      <span>{{ stateName }}</span>
    </v-tooltip>

    <div class="property-title d-flex flex-row">
      <div class="flex-grow-1">State Behavior:</div>
      <v-tooltip location="bottom">
        <template #activator="{ props }">
          <v-btn-icon
            size="fit-content"
            icon="mdi-help-circle-outline"
            v-bind="props"
            href="https://www.itemis.com/en/yakindu/state-machine/documentation/user-guide/quick_ref_states_transitions#quick_ref_state_reactions"
            target="_blank"
          >
          </v-btn-icon>
        </template>
        <span>Open Documentation</span>
      </v-tooltip>
    </div>
    <specification-editor :model="model" :specification="specification" class="bordered" />
    <documentation-editor :model="model" />
    <PrioritiesTable :model="model"></PrioritiesTable>
  </div>
</template>

<script setup lang="ts">
import { State } from "../mvc/state";
import { Transition } from "../mvc/transition";
import SpecificationEditor from "../StatechartDefinitionsView/SpecificationEditor.vue";
import DocumentationEditor from "../StatechartDefinitionsView/DocumentationEditor.vue";
import RappidContext from "../rappid/rappid-context";
import { computed, inject, onBeforeUnmount, onMounted } from "vue";
import PrioritiesTable from "./PrioritiesTable.vue";
import { PreferenceStore } from "./../services/preference-store";

const rappidContext: RappidContext = inject<RappidContext>("rappidContext");

const compProps = defineProps<{
  model: State;
}>();

const emit = defineEmits(["notifyChange"]);

const changeNotifier = (model) => {
  emit("notifyChange", model);
};

onMounted(() => {
  compProps.model.on("change", changeNotifier);
  transitions.value.forEach((t) => {
    t.on("change", changeNotifier, t);
  });
});

onBeforeUnmount(() => {
  transitions.value.forEach((t) => {
    t.off("change", changeNotifier);
  });
  compProps.model.off("change", changeNotifier);
});

function onFocus() {
  rappidContext.commandManager.initBatchCommand();
}

function onBlur() {
  rappidContext.commandManager.storeBatchCommand();
}

const specification = computed((): string => {
  return compProps.model.getSpecification();
});

const stateName = computed({
  get(): string {
    return compProps.model.getName();
  },
  set(name: string) {
    compProps.model.setName(name);
  },
});

const transitions = computed((): Array<Transition> => {
  return compProps.model.getOutgoingTransitions();
});
</script>
